import { css } from "@emotion/react";

import { colors } from "../../../styles";

export const propertyListing = css`
  background-color: ${colors.backgroundGray};
  display: inline-block;
  width: 100%;
  color: ${colors.gray};
  height: 100%;
`;

export const container = css`
  max-width: 85rem;
  margin: 20px auto;
  padding: 0 20px;
  border-radius: 5px;
`;

export const addressPriceContainer = css`
  margin-top: 20px;
  position: relative;
  display: flex;
  align-items: center;
  background-color: ${colors.white};
  padding: 15px;
  border-radius: 5px;
`;

export const addressPrice = css`
  display: inline-block;
  font-size: 1.2em;
`;

export const adddress = css`
  margin: 0;
  margin-left: 1.5rem;
`;

export const moreInfo = css`
  position: absolute;
  right: 15px;
`;

export const detailsContainer = css`
  display: flex;

  @media only screen and (max-width: 64em) {
    flex-wrap: wrap-reverse;
  }
`;

export const agentAndOfficeDetails = css`
  flex-grow: 0;

  @media only screen and (min-width: 40.063em) and (max-width: 64em) {
    display: flex;
  }
`;
